import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {Button, Container} from "react-bootstrap";
import {regularTextStyles, subHeadingStyles} from "../Style";

const PaymentFailure = props => {
  const [searchParams] = useSearchParams();
  const [source, setSource] = useState();
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const [fullName, setFullName] = useState();

  const [loading, setLoading] = useState(true); // Introduce loading state
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
    ? 'carAutosureEvent'
    : window.location.href.includes('quashed')
      ? 'carQuashedEvent'
      : window.location.href.includes('better')
        ? 'carBetterEvent'
        : window.location.href.includes('simplify')
          ? 'carSimplifyEvent'
          : '';
  useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Submit',
        'categoryDetails': 'Payment Transfer Details',
        'status': 'Fail',
        'virtualUrl': `${baseUrl}/vehicle/step5`,
        'pageTitle': 'Payment',
      });
  }, []);

  const proceedWithPayment = () => {
        props.directDebitPage();
    }
    const onClickRedirectTFAF = () => {

        let search = window.location.search;
        let params = new URLSearchParams(search);
        let renewalId = props.inputValues.id;
        props.FirstStepQuote();
    }

    return (
        <>
            <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
                <Container fluid style={{flex: 1}}>
                    <Container>
                        <br/><br/>
                        <p style={subHeadingStyles}>Oops!</p>
                        <p style={regularTextStyles}>Sorry your payment has not been successful. Please try
                            entering your bank details again.</p>

                        <Button variant="primary" onClick={proceedWithPayment} style={{width: "180px"}}>
                            Proceed to payment
                        </Button><br/><br/>
                        <Button variant="secondary" onClick={onClickRedirectTFAF} style={{width: "180px"}}>
                            Go back to quote
                        </Button>
                        <br/><br/>
                        <p style={regularTextStyles}>Thanks</p>

                        <p style={regularTextStyles}>Autosure Car Insurance Team</p>
                    </Container>
                </Container>
            </div>
        </>
    );
}

export default PaymentFailure;
